import * as bootstrap from 'bootstrap';
import 'trix';

// Import Stimulus controllers
import '../controllers';

// Import Bootstrap JavaScript modules
import '../javascripts/bootstrap/site-notice';

// import Rails from '@rails/ujs'
import $ from 'jquery';

window.$ = $;

$(function () {
  // Bootstrap validation setup
  initializeBootstrapValidation();
  preventDirectFileUploads();
  
  // Initialize Bootstrap tooltips
  initializeBootstrapTooltips();

  // Copy to clipboard functionality
  $('.js-copy-to-clipboard').click(function() {
    var text = $('.otp_secret_key').text();

    navigator.clipboard.writeText(text).then(function() {
      alert('Key has been copied to clipboard');
    });
  });
});

function preventDirectFileUploads() {
  $('span.trix-button-group--file-tools,button.trix-button--icon-link').remove();
  document.addEventListener('trix-file-accept', function (event) {
    event.preventDefault();
  });
}

function initializeBootstrapTooltips() {
  // Initialize all Bootstrap tooltips
  const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
  });
}


function initializeBootstrapValidation() {
  // Bootstrap 5 form validation
  const forms = document.querySelectorAll('form[novalidate]');
  
  Array.from(forms).forEach(form => {
    form.addEventListener('submit', event => {
      if (!form.checkValidity()) {
        event.preventDefault();
        event.stopPropagation();
        
        // Focus on first invalid input
        const firstInvalidInput = form.querySelector('.form-control:invalid, .form-select:invalid, .form-check-input:invalid');
        if (firstInvalidInput) {
          firstInvalidInput.focus();
        }
      }
      
      form.classList.add('was-validated');
    }, false);
  });

  // Custom validation patterns
  setupCustomValidation();
}

function setupCustomValidation() {
  // Email validation
  function validateEmail(input) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const value = input.value.trim();
    
    if (!value) return input.required ? false : true;
    
    return emailPattern.test(value);
  }

  // Password validation (minimum 6 characters)
  function validatePassword(input) {
    return input.value.length >= 6;
  }

  // Phone number validation
  function validatePhoneNumber(input) {
    const phonePattern = /^(?=.*\d)[\d ]+$/;
    return phonePattern.test(input.value);
  }

  // Apply custom validation on input events
  $('input[data-pattern="email"]').on('input blur', function() {
    const isValid = validateEmail(this);
    updateValidationState(this, isValid);
  });

  $('input[data-pattern="password"]').on('input blur', function() {
    const isValid = validatePassword(this);
    updateValidationState(this, isValid);
  });

  $('input[data-pattern="phone_number"]').on('input blur', function() {
    const isValid = validatePhoneNumber(this);
    updateValidationState(this, isValid);
  });
}

function updateValidationState(input, isValid) {
  const $input = $(input);
  const feedbackElement = $input.siblings('.invalid-feedback')[0];
  
  if (isValid) {
    $input.removeClass('is-invalid').addClass('is-valid');
    input.setCustomValidity('');
  } else {
    $input.removeClass('is-valid').addClass('is-invalid');
    
    // Set custom validity message
    let message = 'Please enter a valid value';
    if ($input.data('pattern') === 'email') {
      message = 'Please enter a valid email address';
    } else if ($input.data('pattern') === 'password') {
      message = 'Password must be at least 6 characters long';
    } else if ($input.data('pattern') === 'phone_number') {
      message = 'Please enter a valid phone number';
    }
    
    input.setCustomValidity(message);
    
    if (feedbackElement) {
      feedbackElement.textContent = message;
    }
  }
}
